import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/layout/Header";
import Hero from "./components/sections/Hero";
import Experience from "./components/sections/Experience";
import Projects from "./components/sections/Projects";
import Certifications from "./components/sections/Certifications";
import About from "./components/sections/About";
import Contact from "./components/sections/Contact";
import Footer from "./components/layout/Footer";
import ScrollToTopButton from "./components/ui/ScrollToTopButton";
import FloatingParticles from "./components/ui/FloatingParticles";
import SEO from "./components/common/SEO";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import { useAdminShortcut } from "./hooks/useAdminShortcut";

export default function App() {
    // Atajo de teclado secreto: Ctrl+Shift+A para abrir admin
    useAdminShortcut();
    return (
        <>
            <div className="bg-gradient-to-b from-gray-50 via-gray-100 to-gray-200 dark:from-gray-950 dark:via-gray-900 dark:to-gray-800 text-gray-900 dark:text-white min-h-screen relative overflow-hidden">
                {/* Background Effects */}
                <div className="fixed inset-0 overflow-hidden pointer-events-none">
                    {/* Floating Particles */}
                    <FloatingParticles count={40} />

                    {/* Animated gradient orbs */}
                    <div
                        className="absolute top-0 left-0 w-96 h-96 bg-blue-500/10 dark:bg-blue-500/5 rounded-full blur-3xl animate-pulse"
                        style={{ animationDuration: "8s" }}
                    ></div>
                    <div
                        className="absolute bottom-0 right-0 w-96 h-96 bg-purple-500/10 dark:bg-purple-500/5 rounded-full blur-3xl animate-pulse"
                        style={{ animationDuration: "10s", animationDelay: "2s" }}
                    ></div>
                    <div
                        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-500/10 dark:bg-pink-500/5 rounded-full blur-3xl animate-pulse"
                        style={{ animationDuration: "12s", animationDelay: "4s" }}
                    ></div>
                    {/* Grid pattern */}
                    <div className="absolute inset-0 bg-grid-pattern opacity-[0.02] dark:opacity-[0.03]"></div>
                </div>

                {/* SEO Component */}
                <SEO />

                {/* Header */}
                <Header />

                {/* Analytics */}
                <Analytics />
                <SpeedInsights />

                {/* Main Content */}
                <main className="relative z-10 flex-grow px-6 md:px-20 max-w-5xl mx-auto space-y-32 pt-20">
                    <Hero />
                    <Experience />
                    <Projects />
                    {/* <Skills /> */}
                    <Certifications />
                    <About />
                    <Contact />
                    <Footer />
                </main>

                {/* Scroll to Top Button */}
                <ScrollToTopButton />

                {/* Toast Notifications */}
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
            </div>
        </>
    );
}
